import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// Kartu ringkasan: ikon dalam kotak abu, label kecil, angka besar, lalu satu
// baris catatan di bawah garis pemisah. `icon` adalah definisi ikon
// FontAwesome, bukan path gambar.
const InfoCard = ({ title, value, icon, accentColor, note, noteValue }) => {
  return (
    <div className="rounded-card border border-line bg-white shadow-card px-4 py-4 flex flex-col justify-between gap-4">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 flex-none rounded-xl bg-subtle flex items-center justify-center">
          <FontAwesomeIcon
            icon={icon}
            className="text-[15px]"
            style={{ color: accentColor }}
          />
        </div>
        <div className="min-w-0">
          <div className="line-clamp-2 text-[13px] text-muted">{title}</div>
          <div className="text-[28px] leading-9 font-bold text-ink">
            {value}
          </div>
        </div>
      </div>
      {note && (
        <div className="border-t border-line pt-3 flex items-center justify-between gap-2 text-[13px]">
          <span className="flex items-center gap-2 text-muted min-w-0">
            <span
              className="w-1.5 h-1.5 rounded-full flex-none"
              style={{ backgroundColor: accentColor }}
            />
            <span className="truncate">{note}</span>
          </span>
          <span className="font-semibold" style={{ color: accentColor }}>
            {noteValue}
          </span>
        </div>
      )}
    </div>
  )
}

export default InfoCard
